var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.87216 13C2.53538 13 2.25033 12.8833 2.01699 12.65C1.78366 12.4167 1.66699 12.1316 1.66699 11.7948V4.20517C1.66699 3.86839 1.78366 3.58333 2.01699 3.35C2.25033 3.11667 2.53538 3 2.87216 3H13.1285C13.4653 3 13.7503 3.11667 13.9837 3.35C14.217 3.58333 14.3337 3.86839 14.3337 4.20517V11.7948C14.3337 12.1316 14.217 12.4167 13.9837 12.65C13.7503 12.8833 13.4653 13 13.1285 13H2.87216ZM8.00033 8.37183L2.66699 4.9615V11.7948C2.66699 11.8547 2.68621 11.9039 2.72466 11.9423C2.7631 11.9808 2.81227 12 2.87216 12H13.1285C13.1884 12 13.2375 11.9808 13.276 11.9423C13.3144 11.9039 13.3337 11.8547 13.3337 11.7948V4.9615L8.00033 8.37183ZM8.00033 7.33333L13.2312 4H2.76949L8.00033 7.33333ZM2.66699 4.9615V4V11.7948C2.66699 11.8547 2.68621 11.9039 2.72466 11.9423C2.7631 11.9808 2.81227 12 2.87216 12H2.66699V4.9615Z",
    fill: "#3B84E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.0f1d58434cf24af7489b5d338f9acb0f.svg";
export { ForwardRef as ReactComponent };